import React from "react"

import {EGTMEvent, emitGTMEvent} from "../../../../utils/gtm.tsx"
import {AdvancedSearch} from "../../ProspectsFromLeads/AdvancedSearch/AdvancedSearch.tsx"
import {PFLContext} from "../../ProspectsFromLeads/AdvancedSearch/context/context.ts"
import {usePFLContext} from "../../ProspectsFromLeads/AdvancedSearch/context/usePFLContext.ts"
import {BasicSearch} from "../../ProspectsFromLeads/BasicSearch.tsx"
import {ProspectsContext} from "../context.ts"

export const LeadsStep: React.FC<{onClose: () => void}> = ({onClose}) => {
  const {salesCycle} = ProspectsContext.useContext()

  React.useEffect(() => {
    emitGTMEvent({event: EGTMEvent.LEADS_SEARCH})
  }, [])

  const pflContextValue = usePFLContext(onClose, salesCycle || {advanced_search_enabled: false})
  const {isAdvancedFiltering} = pflContextValue

  // Show nothing until salesCycle is loaded
  if (!salesCycle) {
    return null
  }

  return <PFLContext value={pflContextValue}>{isAdvancedFiltering ? <AdvancedSearch /> : <BasicSearch />}</PFLContext>
}
